/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
import type { ReactNode } from 'react';
import { styled } from '@compiled/react';
import { fontFallback } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div<{
	children?: ReactNode;
}>({
	margin: `${token('space.300', '24px')} ${token('space.400', '32px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableContainer = styled.div<{
	children?: ReactNode;
}>({
	margin: `${token('space.250', '20px')} 0 ${token('space.600', '48px')}`,
	tr: {
		display: 'flex',
	},
	td: {
		display: 'flex',
		verticalAlign: 'top',
	},
	p: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		font: token('font.body.small', fontFallback.body.small),
		textAlign: 'center',
		paddingTop: `${token('space.100', '8px')}`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableCell = styled.div<{
	isLocked?: boolean;
	children?: ReactNode;
	['data-testid']: string;
}>({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: token('space.100', '8px'),
	height: '100%',
	margin: `${token('space.200', '16px')} 0`,
	button: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		cursor: ({ isLocked }) => (isLocked ? 'not-allowed' : 'pointer'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		font: token('font.body.small', fontFallback.body.small),
		display: 'flex',
		alignItems: 'center',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CellItem = styled.div<{
	children?: ReactNode;
}>({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.075', '6px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- PLEASE FIX - ENABLING FLAT LINT CONFIG
	font: token('font.body.small', fontFallback.body.small),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PriorityIconContainer = styled.img({
	maxWidth: token('space.300', '24px'),
	maxHeight: token('space.300', '24px'),
});
